import { getClientStatusLabel } from '../../utils/client';
import { toCapitalizeCase } from 'utils/helpers';

export default clients => clients.map(client => ({
  ...client,
  quantity: 0,
  isVisible: true,
  isSelected: false,
  riskValidated: false,
  nome: client?.nome?.toLowerCase(),
  impedimentsMessage: getClientStatusLabel(client),
  suitability: toCapitalizeCase(client.suitability),
}));
